const key = (tagName, action) => `${tagName}::${action}`;

// Ongoing actions (reading, watching, ...) are flagged on the tag's action
// metadata. They must never count as completed experiences.
export const buildOngoingLookup = (tags = []) => {
    const lookup = new Set();
    tags.forEach(t => (t.actions || []).forEach(a => {
        if (a?.isOngoing) lookup.add(key(t.name, a.name));
    }));
    return lookup;
}

// /users/:id/stats returns one { tag_name, action, count } row per
// category/action pair, where count is the number of action records.
export const groupCompletedStats = (stats = [], ongoing = new Set()) => {
    const byTag = new Map();
    (stats || []).forEach(s => {
        const tagName = s?.tag_name;
        const action = s?.action;
        const count = Number(s?.count);
        if (!tagName || !action || !Number.isFinite(count)) return;
        if (ongoing.has(key(tagName, action))) return;
        if (!byTag.has(tagName)) byTag.set(tagName, { tagName, total: 0, actions: [] });
        const group = byTag.get(tagName);
        group.total += count;
        group.actions.push({ action, count });
    });
    return Array.from(byTag.values())
        .map(g => ({ ...g, actions: g.actions.sort((a, b) => b.count - a.count) }))
        .sort((a, b) => b.total - a.total || a.tagName.localeCompare(b.tagName));
}
